import type { Language } from './types';

export const SUPPORTED_LANGUAGES: Array<{ code: Language; label: string }> = [
  { code: 'es', label: 'Español' },
  { code: 'en', label: 'English' },
];

const LANGUAGE_KEY = 'scribe_language';

export function getLanguage(): Language {
  const stored = localStorage.getItem(LANGUAGE_KEY) as Language | null;
  if (stored === 'es' || stored === 'en') return stored;
  return 'es';
}

export function setLanguage(lang: Language): void {
  localStorage.setItem(LANGUAGE_KEY, lang);
}
